var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imgShow"},[_c('div',{staticClass:"imgbox"},[_c('img',{attrs:{"id":"showPic","src":_vm.imgsrc,"width":"400px","height":"300px"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }